import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import CollectionCard from "./CollectionCard";
import productImg from '../Data/dress/productsimg/1.png';
import productImg2 from '../Data/dress/productsimg/8.png';
import productImg3 from '../Data/dress/productsimg/10.png';
import productImg4 from '../Data/dress/productsimg/11.png';
import productImg5 from '../Data/dress/productsimg/13.png';
import productImg6 from '../Data/dress/productsimg/14.png';
import { useNavigate } from "react-router-dom";

const ProductSlider = () => {
  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    mode: "snap",
    slides: {
      perView: 3,
      spacing: 20,
    },
    breakpoints: {
      "(max-width: 1024px)": {
        slides: {
          perView: 2.15,
          spacing: 15,
        },
      },
      "(max-width: 640px)": {
        slides: {
          perView: 1.2,
          spacing: 12,
        },
      },
    },
  });
  const navigate = useNavigate()
  const products = [
    {
      title: "INCENSE STICKS",
      items: "6 items",
      image: productImg,
      description: "Econirmit", 
      path : "/product/econirmit/all?title=agarbatti"

    },
    {
      title: "INCENSE CONES",
      items: "4 items",
      image: productImg2,
      description: "Econirmit",
         path : "/product/econirmit/all?title=cones"
    },
    {
      title: "INCENSE CUPS",
      items: "1 item",
      image: productImg3,
      description: "Econirmit",
         path : "/product/econirmit/all?title=cups"
    },
    {
      title: "GIFT HAMPERS",
      items: "1 item",
      image: productImg4,
      description: "Econirmit",
      path : "/product/econirmit/all?title=gift"
    },
    {
      title: "GULAB JAL",
      items: "1 item",
      image: productImg5,
      description: "Econirmit",
      path : "/product/econirmit/all?title=gulab"
    },
    {
      title: "ASHTAGANDHA",
      items: "1 item",
      image: productImg6,
      description: "Econirmit",
      path : "/product/econirmit/all?title=ashtagandh"

    }
  ];

  return (
    <div className="py-12 px-4 md:px-10 bg-[#F3EEEA]">
      <div className="flex flex-col lg:flex-col items-start gap-8">
        
        {/* Left Content */}
        <div className="w-full lg:w-1/3 px-4 text-center lg:text-left">
          <h1 className="text-xl sm:text-2xl font-medium mb-2">
            Pure Source, Divine Force
          </h1>
          <h2
            className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 leading-tight"
            style={{ wordBreak: "break-word", maxWidth: "100%" }}
          >
            Explore Our Top Collection
          </h2>
          <p className="text-gray-500 mb-6 text-base sm:text-lg">
            Our top collections handpicked for you!
          </p>
        </div>

        {/* Right Slider */}
        <div className="w-full lg:w-2/3">
          <div className="relative">
            {/* Arrow buttons */}
            <button
              onClick={() => instanceRef.current?.prev()}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 bg-white border border-gray-200 shadow-md rounded-full w-9 h-9 flex items-center justify-center text-gray-700 hover:bg-gray-50 transition hidden sm:flex"
              aria-label="Previous"
            >
              ‹
            </button>
            <button
              onClick={() => instanceRef.current?.next()}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 bg-white border border-gray-200 shadow-md rounded-full w-9 h-9 flex items-center justify-center text-gray-700 hover:bg-gray-50 transition hidden sm:flex"
              aria-label="Next"
            >
              ›
            </button>

            {/* Mobile swipe hint */}
            <p className="text-xs text-gray-400 text-right mb-2 sm:hidden flex items-center justify-end gap-1">
              <span>Swipe to explore</span>
              <span>→</span>
            </p>

            <div ref={sliderRef} className="keen-slider">
              {products.map((product, index) => (
                <div key={index} className="keen-slider__slide" onClick={() => navigate(product.path)}>
                  <div className="rounded-lg h-full border border-gray-100 bg-white p-4" style={{ borderRadius: "20px" }}>
                    <CollectionCard
                      title={product.title}
                      items={product.items}
                      image={product.image}
                      description={product.description}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ProductSlider;
